import { PublicClientApplication } from '@azure/msal-browser'

const env = (<any>window)['appenv']
const isLocal = env?.isLocal === 'true';

const msalConfig = {
    auth: {
        clientId: env.clientId, // Azure AD app's client ID
        authority: env.authority, // Azure AD authority
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}

export const msalInstance = new PublicClientApplication(msalConfig)
